import { useEffect, useState } from 'react';
import { Holiday, PRIMARY_COLORS, SECONDARY_COLORS } from './constants';

export function useHolidayMode() {
  const [holiday, setHoliday] = useState<Holiday | undefined>(undefined);

  useEffect(() => {
    const today = new Date();

    function getThanksgivingDate(year: number): Date {
      const november = 10; // November index (0-based index: 10 = November)
      const firstDayOfNovember = new Date(year, november, 1);
      // Calculate how many days to add to get to the first Thursday.
      const offset = (4 - firstDayOfNovember.getDay() + 7) % 7;
      // First Thursday is on the (1 + offset) day of November.
      // The fourth Thursday is 3 weeks (21 days) after the first Thursday.
      const fourthThursday = 1 + offset + 21;
      return new Date(year, november, fourthThursday);
    }

    const thanksgivingDate = getThanksgivingDate(today.getFullYear());
    const christmasDate = new Date(today.getFullYear(), 11, 25);

    const oneWeekInMillis = 7 * 24 * 60 * 60 * 1000;

    const isThanksgivingWeek =
      Math.abs(today.getTime() - thanksgivingDate.getTime()) <= oneWeekInMillis;
    const isChristmasWeek = Math.abs(today.getTime() - christmasDate.getTime()) <= oneWeekInMillis;

    if (isChristmasWeek) {
      setHoliday('CHRISTMAS');
    } else if (isThanksgivingWeek) {
      setHoliday('THANKSGIVING');
    }
  }, []);

  return holiday
    ? {
        holiday,
        primaryColor: PRIMARY_COLORS[holiday],
        secondaryColor: SECONDARY_COLORS[holiday],
      }
    : null;
}
